export default {
  GROUP: 'Groups',
  WORKFLOWS: 'Workflows',
  FORMS: 'Form Builder',
  CCB: 'Integration - CCB',
  MC: 'Integration - MC',
  PCO: 'Integration - PCO',
  ROCK: 'Integration - Rock RMS',
  SOCIALSYNC: 'Integration - Social Profile Sync',
  ZAPIER: 'Integration - Zapier',
  EMAIL: 'Messaging - Email',
  SMS: 'Messaging - SMS',
  VIDEO: 'Messaging - Video',
  BROADCAST: 'Voice Broadcasts',
  MSG_SEND_TO_ALL_CONTACTS: 'Messaging - Send to All Contacts',
  DIGIGIV: 'Integration - DigiGiv',
  CONNECT_CARD: 'Connection Cards',
  DEVELOPER_ACCESS: 'Developer Access',
  TALK_VOICEMAIL: 'Talk - Voicemails',
  TALK_DIGITAL_RECEPTION: 'Talk - Digital Receptionist',
  TALK_TEAM: 'Talk - Teams',
  TALK_OPERATOR: 'Talk - Operators',
  PCO_INSTANT_SYC: 'Integration - PCO - Real-time',
  PEOPLE_PREMIUM: 'People Premium',
};
